import { PERFORMANCE_TYPE_KEYS } from './performance-type.const';

export const PERFORMANCE_TYPES_REFERENCE = [
  { id: PERFORMANCE_TYPE_KEYS.SINGLE, displayValue: 'Single' },
  { id: PERFORMANCE_TYPE_KEYS.BASKET, displayValue: 'Basket' },
];
